<template>
    <div id="app">
        <OrderMessage style="position: fixed; z-index: 1000"></OrderMessage>
        <router-view/>
    </div>
</template>

<script>
    import OrderMessage from "./components/app/OrderMessage"

    export default {
        name: 'App',
        components: {OrderMessage}
    }
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin: 0 auto;
        height: 100vh;
        /* 背景色改为 F4F4F4 */
        background-color: #F4F4F4;
        background-size: cover;
        background-attachment: fixed;
        background-position: center;
    }

    a {
        text-decoration: none;
        color: #000;
    }

    /* 自定义删除确认弹窗样式 */
    .custom-delete-confirm {
        width: 420px;/* 自适应内容高度 */
        border-radius: 12px;
    }

    .custom-delete-confirm .el-message-box__header {
        padding: 32px 36px 0px;
    }

    .custom-delete-confirm .el-message-box__headerbtn {
        right: 36px; /* 强制关闭图标距离右侧 25px */
        top: 32px;
    }

    .custom-delete-confirm .el-message-box__title {
        font-weight: bold;
        font-size: 18px;
        color: #333;
        text-align: left;
    }

    .custom-delete-confirm .el-message-box__content {
        padding: 24px 36px 36px;
        color: #999;
        font-size: 14px;
        text-align: justify;
    }

    .custom-delete-confirm .el-message-box__btns {
        padding: 0 0px 22px 0; /* 左边距25px，右边距0，顶部边距0 */
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-start; /* 改为flex-start，让按钮从右边开始排列 */
    }

    .custom-delete-confirm .el-message-box__btns button {
        width: 80px;
        height: 34px;
        border-radius: 6px;
        font-weight: 500;
        margin: 0; /* 清除所有默认边距 */
    }

    /* 由于 flex-direction: row-reverse，DOM中第一个按钮（取消）显示在右边 */
    /* 取消按钮右对齐到关闭图标 */
    .custom-delete-confirm .el-message-box__btns button:first-child {
        margin-right: 36px; /* 取消按钮右边距36px，与关闭图标对齐 */
    }

    /* 确认按钮与取消按钮之间的间距 */
    .custom-delete-confirm .el-message-box__btns button:last-child {
        margin-right: 12px; /* 确认按钮右边距12px，作为按钮间隔 */
    }

    /* 确认按钮样式（变到了左边） */
    .confirm-btn-green {
        background-color: #007549 !important;
        border-color: #007549 !important;
        color: #fff !important;
    }

    .confirm-btn-green:hover,
    .confirm-btn-green:focus,
    .confirm-btn-green:active {
        background-color: #007549 !important;
        border-color: #007549 !important;
        color: #fff !important;
    }

    /* 取消按钮样式（变到了右边） */
    .cancel-btn-white {
        background-color: #fff !important;
        border-color: #007549 !important;
        color: #007549 !important;
    }

    .cancel-btn-white:hover,
    .cancel-btn-white:focus,
    .cancel-btn-white:active {
        background-color: #fff !important;
        border-color: #007549 !important;
        color: #007549 !important;
    }

    .custom-delete-confirm .el-message-box__close {
        font-size: 20px;
    }

    /* 自定义普通弹窗样式 (如新增/更新用户) */
    body .el-dialog.custom-dialog {
        border-radius: 16px;
        overflow: hidden;
        box-shadow: 0 12px 32px 4px rgba(0, 0, 0, .1);
    }

    body .custom-dialog .el-dialog__header {
        padding: 32px 36px 0px;
        text-align: left; /* 提高权重后，可直接覆盖 #app 的 center */
    }

    body .custom-dialog .el-dialog__title {
        font-weight: bold;
        font-size: 18px;
        color: #333;
        line-height: 1;
        display: block;
    }

    body .custom-dialog .el-dialog__headerbtn {
        top: 32px;
        right: 36px;
    }

    body .custom-dialog .el-dialog__body {
        padding: 0px 36px 10px;
    }

    body .custom-dialog .el-dialog__footer {
        padding: 0 36px 32px;
    }

    /* 通知提示框图标与文字垂直居中对齐 - 通过增加 body 前缀提高权重，移除 !important */
    body .el-notification {
        display: flex;
        align-items: center;
        padding: 14px 26px 14px 13px;
    }

    body .el-notification__group {
        margin-left: 10px;
        margin-right: 8px;
        display: flex;
        align-items: center;
    }

    body .el-notification__title {
        margin: 0;
        line-height: 1;
        display: flex;
        align-items: center;
    }

    body .el-notification__content {
        margin: 0;
        line-height: 1.4;
    }

    body .el-notification__icon {
        height: auto;
        display: flex;
        align-items: center;
    }

    /* 全局分页组件样式覆盖 - 强制主题绿，彻底移除所有动画效果 */
    body .el-pagination.is-background .el-pager li,
    body .el-pagination.is-background .el-pager li *,
    body .el-pagination.is-background .el-pager li::before,
    body .el-pagination.is-background .el-pager li::after,
    body .el-pagination.is-background .el-pager li.active,
    body .el-pagination.is-background .el-pager li:hover {
        transition: none !important;
        animation: none !important;
    }

    body .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #007549 !important;
        color: #fff !important;
        transition: none !important;
        animation: none !important;
    }

    body .el-pagination.is-background .el-pager li:not(.disabled):not(.active):hover {
        color: #007549 !important;
        transition: none !important;
        animation: none !important;
    }

    /* 彻底禁用 el-pagination 的所有过渡效果 */
    body .el-pagination,
    body .el-pagination *,
    body .el-pagination *::before,
    body .el-pagination *::after {
        transition: none !important;
        animation: none !important;
        transition-duration: 0s !important;
    }

    body .el-input-number .el-input__inner:focus {
        border-color: #007549 !important;
    }

    /* 移除原生数字输入框的上下箭头 (Spinners) */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }

    /* 仅针对单按钮的删除/确认弹窗（例如未登录提示），按钮右边距调整为36px */
    .custom-delete-confirm.single-btn-confirm .el-message-box__btns button {
        margin-right: 36px !important;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue